<script lang="ts">
    import {Datatable} from "svelte-simple-datatables"
    import { tableData } from "../../../../Data/Ecommerce/ProductList/ProductList";
    import ProductListTable from "./ProductListTable.svelte";
    const settings = {
        pagination: true,
        scrollY: true,
        scrollX: true,
        rowsPerPage: 9,
        sortable: true,
    };
    let rows:any;
    
</script>
<Datatable {settings} class="display" data={tableData} bind:dataRows={rows}>
    <thead>
      <tr>
        <th data-key="img">{'Image'}</th>
        <th data-key="title">{'Details'}</th>
        <th data-key="price">{'Amount'}</th>
        <th data-key="stock">{'Stock'}</th>
        <th data-key="date">{'Start date'}</th>
        <th data-key="btn1">{'Action'}</th>
      </tr>
    </thead>
    <tbody>
        <ProductListTable rows={rows}/>
    </tbody>
</Datatable>